import {
  queryPostCountStats as publicQueryPostCountStats,
  getTotalPosts as publicGetTotalPosts,
  getPost as publicGetPost,
  getPostBySlug as publicGetPostBySlug,
  listPosts as publicListPosts,
  queryPosts as publicQueryPosts,
  typedQueryPosts as publicTypedQueryPosts,
  getPostMetrics as publicGetPostMetrics,
} from './blog-v3-post-posts.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  PostQuery,
  PostsQueryBuilder,
  QueryPostsOptions,
  typedQueryPosts as universalTypedQueryPosts,
} from './blog-v3-post-posts.universal.js';
import { onPostLiked as publicOnPostLiked } from './blog-v3-post-posts.public.js';
import { onPostUnliked as publicOnPostUnliked } from './blog-v3-post-posts.public.js';
import { onPostCreated as publicOnPostCreated } from './blog-v3-post-posts.public.js';
import { onPostDeleted as publicOnPostDeleted } from './blog-v3-post-posts.public.js';
import { onPostUpdated as publicOnPostUpdated } from './blog-v3-post-posts.public.js';

function customQueryPosts(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryPostsOptions) =>
      publicQueryPosts(httpClient)(options),
    typedQueryFunction: (query: PostQuery, options?: QueryPostsOptions) =>
      publicTypedQueryPosts(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: PostQuery,
    options?: QueryPostsOptions
  ): ReturnType<typeof universalTypedQueryPosts>;
  function overloadedQuery(options?: QueryPostsOptions): PostsQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: PostQuery | QueryPostsOptions,
    options?: QueryPostsOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const queryPostCountStats: MaybeContext<
  BuildRESTFunction<typeof publicQueryPostCountStats> &
    typeof publicQueryPostCountStats
> = /*#__PURE__*/ createRESTModule(publicQueryPostCountStats);
export const getTotalPosts: MaybeContext<
  BuildRESTFunction<typeof publicGetTotalPosts> & typeof publicGetTotalPosts
> = /*#__PURE__*/ createRESTModule(publicGetTotalPosts);
export const getPost: MaybeContext<
  BuildRESTFunction<typeof publicGetPost> & typeof publicGetPost
> = /*#__PURE__*/ createRESTModule(publicGetPost);
export const getPostBySlug: MaybeContext<
  BuildRESTFunction<typeof publicGetPostBySlug> & typeof publicGetPostBySlug
> = /*#__PURE__*/ createRESTModule(publicGetPostBySlug);
export const listPosts: MaybeContext<
  BuildRESTFunction<typeof publicListPosts> & typeof publicListPosts
> = /*#__PURE__*/ createRESTModule(publicListPosts);
export const getPostMetrics: MaybeContext<
  BuildRESTFunction<typeof publicGetPostMetrics> & typeof publicGetPostMetrics
> = /*#__PURE__*/ createRESTModule(publicGetPostMetrics);
export const queryPosts: MaybeContext<
  BuildRESTFunction<typeof customQueryPosts> & typeof customQueryPosts
> = /*#__PURE__*/ createRESTModule(customQueryPosts);
/** */
export const onPostLiked: BuildEventDefinition<typeof publicOnPostLiked> &
  typeof publicOnPostLiked = createEventModule(publicOnPostLiked);
/** */
export const onPostUnliked: BuildEventDefinition<typeof publicOnPostUnliked> &
  typeof publicOnPostUnliked = createEventModule(publicOnPostUnliked);
/**
 * Triggered when a post is created.
 */
export const onPostCreated: BuildEventDefinition<typeof publicOnPostCreated> &
  typeof publicOnPostCreated = createEventModule(publicOnPostCreated);
/**
 * Triggered when a post is deleted.
 */
export const onPostDeleted: BuildEventDefinition<typeof publicOnPostDeleted> &
  typeof publicOnPostDeleted = createEventModule(publicOnPostDeleted);
/**
 * Triggered when a post is updated.
 */
export const onPostUpdated: BuildEventDefinition<typeof publicOnPostUpdated> &
  typeof publicOnPostUpdated = createEventModule(publicOnPostUpdated);

export {
  NodeType,
  BackgroundType,
  GradientType,
  WidthType,
  PluginContainerDataAlignment,
  ButtonDataType,
  Target,
  TextAlignment,
  LineStyle,
  Width,
  DividerDataAlignment,
  ViewMode,
  LayoutType,
  Orientation,
  Crop,
  ThumbnailsAlignment,
  GIFType,
  Source,
  StylesPosition,
  MapType,
  ViewRole,
  VoteRole,
  PollLayoutType,
  PollLayoutDirection,
  PollDesignBackgroundType,
  DecorationType,
  FontType,
  Position,
  AspectRatio,
  Resizing,
  Placement,
  Type,
  Alignment,
  Layout,
  AppType,
  InitialExpandedItems,
  Direction,
  VerticalAlignment,
  NullValue,
  ImageScalingScaling,
  ImagePosition,
  BannerOrigin,
  BannerPosition,
  LayoutDataBackgroundType,
  BackdropType,
  VerticalAlignmentAlignment,
  ResponsivenessBehaviour,
  DesignTarget,
  Scaling,
  ImagePositionPosition,
  CardDataBackgroundType,
  ListStyle,
  Indentation,
  SmartBlockDataType,
  ColumnSize,
  ModerationStatusStatus,
  GetPostTemplatesSort,
  Origin,
  Status,
  WebhookIdentityType,
  QueryPublicationsCountStatsRequestOrder,
  Order,
  Field,
  PostFieldField,
  GetPostsSort,
  SortOrder,
} from './blog-v3-post-posts.universal.js';
export {
  Post,
  PostCountInfo,
  FocalPoint,
  Metrics,
  SeoSchema,
  Keyword,
  Tag,
  Settings,
  RichContent,
  Node,
  NodeDataOneOf,
  NodeStyle,
  ButtonData,
  Gradient,
  Stop,
  Border,
  Colors,
  Background,
  PluginContainerData,
  PluginContainerDataWidth,
  PluginContainerDataWidthDataOneOf,
  Spoiler,
  Height,
  Styles,
  Link,
  LinkDataOneOf,
  Rel,
  CodeBlockData,
  TextStyle,
  DividerData,
  FileData,
  FileSource,
  FileSourceDataOneOf,
  PDFSettings,
  GalleryData,
  V1Media,
  Image,
  Video,
  Item,
  ItemDataOneOf,
  GalleryOptions,
  GalleryOptionsLayout,
  ItemStyle,
  Thumbnails,
  GIFData,
  GIF,
  HeadingData,
  HTMLData,
  HTMLDataDataOneOf,
  ImageData,
  StylesBorder,
  ImageDataStyles,
  LinkPreviewData,
  LinkPreviewDataStyles,
  MapData,
  MapSettings,
  ParagraphData,
  PollData,
  Permissions,
  Option,
  PollSettings,
  PollLayout,
  OptionLayout,
  BackgroundGradient,
  PollDesignBackground,
  PollDesignBackgroundBackgroundOneOf,
  PollDesign,
  OptionDesign,
  Poll,
  PollDataLayout,
  Design,
  TextData,
  Decoration,
  DecorationDataOneOf,
  AnchorData,
  ColorData,
  LinkData,
  MentionData,
  FontSizeData,
  SpoilerData,
  FontFamilyData,
  AppEmbedData,
  AppEmbedDataAppDataOneOf,
  BookingData,
  EventData,
  ButtonStyles,
  ImageStyles,
  RibbonStyles,
  CardStyles,
  PricingData,
  VideoData,
  PlaybackOptions,
  EmbedData,
  Oembed,
  CollapsibleListData,
  TableData,
  Dimensions,
  TableCellData,
  CellStyle,
  BorderColors,
  BorderWidths,
  ListValue,
  AudioData,
  OrderedListData,
  BulletedListData,
  BlockquoteData,
  CaptionData,
  LayoutData,
  LayoutDataBackgroundImage,
  Banner,
  LayoutDataBackground,
  Backdrop,
  LayoutCellData,
  ShapeData,
  ShapeDataStyles,
  CardData,
  CardDataBackground,
  BackgroundImage,
  TocData,
  SmartBlockData,
  SmartBlockCellData,
  Metadata,
  DocumentStyle,
  TextNodeStyle,
  ModerationDetails,
  Media,
  MediaMediaOneOf,
  WixMedia,
  VideoResolution,
  EmbedMedia,
  EmbedThumbnail,
  EmbedVideo,
  PostTranslation,
  PostCategoriesUpdated,
  PostTagsUpdated,
  ScheduledPostPublished,
  PostLiked,
  PostLikedInitiatorOneOf,
  PostUnliked,
  PostUnlikedInitiatorOneOf,
  ListTemplatesRequest,
  BlogPaging,
  ListTemplatesResponse,
  MetaData,
  Category,
  CategoryTranslation,
  GetTemplateRequest,
  GetTemplateResponse,
  CreateDraftPostFromTemplateRequest,
  CreateDraftPostFromTemplateResponse,
  DraftPost,
  DraftPostTranslation,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  QueryPublicationsCountStatsRequest,
  QueryPublicationsCountStatsResponse,
  PeriodPublicationsCount,
  QueryPostCountStatsRequest,
  QueryPostCountStatsResponse,
  PeriodPostCount,
  GetTotalPublicationsRequest,
  GetTotalPublicationsResponse,
  GetTotalPostsRequest,
  GetTotalPostsResponse,
  GetTotalLikesPerMemberRequest,
  GetTotalLikesPerMemberResponse,
  PostCountersUpdated,
  PostCountersUpdatedInitiatorOneOf,
  PostOwnerChanged,
  InitialPostsCopied,
  GetPostRequest,
  GetPostResponse,
  GetPostBySlugRequest,
  GetPostBySlugResponse,
  ListPostsRequest,
  ListPostsResponse,
  QueryPostsRequest,
  Sorting,
  PlatformQuery,
  PlatformQueryPagingMethodOneOf,
  Paging,
  CursorPaging,
  QueryPostsResponse,
  PagingMetadataV2,
  Cursors,
  GetPostMetricsRequest,
  GetPostMetricsResponse,
  ViewPostRequest,
  ViewPostResponse,
  LikePostRequest,
  LikePostResponse,
  UnlikePostRequest,
  UnlikePostResponse,
  PinPostRequest,
  PinPostResponse,
  UnpinPostRequest,
  UnpinPostResponse,
  ListPostsArchiveRequest,
  ListPostsArchiveResponse,
  GetPostCountPerMonthRequest,
  GetPostCountPerMonthResponse,
  PostCountPerMonth,
  BulkGetPostReactionsRequest,
  BulkGetPostReactionsResponse,
  Reactions,
  DeletePostRequest,
  DeletePostResponse,
  BulkDeletePostsRequest,
  BulkDeletePostsResponse,
  GetPostCountsRequest,
  GetPostCountsResponse,
  PostCount,
  ListDemoPostsRequest,
  ListDemoPostsResponse,
  ConvertDraftJsToRichContentRequest,
  ConvertDraftJsToRichContentResponse,
  ConvertRichContentToDraftJsRequest,
  ConvertRichContentToDraftJsResponse,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  PostLikedEnvelope,
  PostUnlikedEnvelope,
  PostCreatedEnvelope,
  PostDeletedEnvelope,
  PostUpdatedEnvelope,
  QueryPostCountStatsOptions,
  GetTotalPostsOptions,
  GetPostOptions,
  GetPostBySlugOptions,
  ListPostsOptions,
  QueryPostsOptions,
  PostsQueryResult,
  PostsQueryBuilder,
  PostQuerySpec,
} from './blog-v3-post-posts.universal.js';
export { utils } from './blog-v3-post-posts.universal.js';
export {
  NodeTypeWithLiterals,
  BackgroundTypeWithLiterals,
  GradientTypeWithLiterals,
  WidthTypeWithLiterals,
  PluginContainerDataAlignmentWithLiterals,
  ButtonDataTypeWithLiterals,
  TargetWithLiterals,
  TextAlignmentWithLiterals,
  LineStyleWithLiterals,
  WidthWithLiterals,
  DividerDataAlignmentWithLiterals,
  ViewModeWithLiterals,
  LayoutTypeWithLiterals,
  OrientationWithLiterals,
  CropWithLiterals,
  ThumbnailsAlignmentWithLiterals,
  GIFTypeWithLiterals,
  SourceWithLiterals,
  StylesPositionWithLiterals,
  MapTypeWithLiterals,
  ViewRoleWithLiterals,
  VoteRoleWithLiterals,
  PollLayoutTypeWithLiterals,
  PollLayoutDirectionWithLiterals,
  PollDesignBackgroundTypeWithLiterals,
  DecorationTypeWithLiterals,
  FontTypeWithLiterals,
  PositionWithLiterals,
  AspectRatioWithLiterals,
  ResizingWithLiterals,
  PlacementWithLiterals,
  TypeWithLiterals,
  AlignmentWithLiterals,
  LayoutWithLiterals,
  AppTypeWithLiterals,
  InitialExpandedItemsWithLiterals,
  DirectionWithLiterals,
  VerticalAlignmentWithLiterals,
  NullValueWithLiterals,
  ImageScalingScalingWithLiterals,
  ImagePositionWithLiterals,
  BannerOriginWithLiterals,
  BannerPositionWithLiterals,
  LayoutDataBackgroundTypeWithLiterals,
  BackdropTypeWithLiterals,
  VerticalAlignmentAlignmentWithLiterals,
  ResponsivenessBehaviourWithLiterals,
  DesignTargetWithLiterals,
  ScalingWithLiterals,
  ImagePositionPositionWithLiterals,
  CardDataBackgroundTypeWithLiterals,
  ListStyleWithLiterals,
  IndentationWithLiterals,
  SmartBlockDataTypeWithLiterals,
  ColumnSizeWithLiterals,
  ModerationStatusStatusWithLiterals,
  GetPostTemplatesSortWithLiterals,
  OriginWithLiterals,
  StatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
  QueryPublicationsCountStatsRequestOrderWithLiterals,
  OrderWithLiterals,
  FieldWithLiterals,
  PostFieldFieldWithLiterals,
  GetPostsSortWithLiterals,
  SortOrderWithLiterals,
  CommonQueryWithEntityContext,
  PostQuery,
} from './blog-v3-post-posts.universal.js';
